export default __webpack_public_path__ + "static/media/14.0df2649b.jpg";